import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { connect } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { Transition } from 'react-transition-group';
import ContactService from 'api/contactService';
import { Heading, Text } from 'components/styled/ui';
import { Input, Textarea, Button, Form } from 'components/layouts/react-validation';
import validator from 'validator';
import { images, strings } from 'config';
var Recaptcha = require('react-recaptcha');

const requiredName = value => {
  if (!value.toString().trim().length) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return <span className="error">{strings.contact.error.name}</span>;
  }
};

const requiredEmail = value => {
  if (!value.toString().trim().length) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return <span className="error">{strings.contact.error.emailRequired}</span>;
  }
};

const requiredMessage = value => {
  if (!value.toString().trim().length) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return <span className="error">{strings.contact.error.message}</span>;
  }
};

const email = value => {
  if (!validator.isEmail(value)) {
    return (
      <span className="error">
        {value} {strings.contact.error.emailInvalid}
      </span>
    );
  }
};

class Contact extends Component {
  constructor() {
    super();

    this.state = {
      isOpen: false,
      contact: {
        name: '',
        email: '',
        message: ''
      },
      showToast: false,
      toastType: '',
      cursor: 'not-allowed',
      captchaValidated: false,
      contactFormVisible: true
    };
  }

  menuToggle = () => {
    this.setState(
      {
        isOpen: !this.state.isOpen
      },
      () => {
        this.props.isContactOpen(this.state.isOpen);
      }
    );
  };

  handleClick = () => {
    this.changeRecaptchaText();
  };

  handleOnChange = e => {
    let newContact = this.state.contact;
    const name = e.target.name;
    newContact[name] = e.target.value;

    this.setState({
      contact: newContact
    });
  };

  getMunForContact = () => {
    const { selectedMun, detailPageMun } = this.props;

    if (this.props.location.pathname.indexOf('detail') === 1) {
      return detailPageMun;
    } else if (selectedMun) {
      return selectedMun;
    } else {
      return 0;
    }
  };

  clearInputErrors = () => {
    this.form.hideError(this.userInputName);
    this.form.hideError(this.userInputEmail);
    this.form.hideError(this.userInputMessage);
  };

  handleFormSubmit = e => {
    e.preventDefault();

    const selectedMun = this.getMunForContact();

    ContactService.saveContact(selectedMun, this.state.contact).then(response => {
      if (response.status === 200) {
        // this.props.onMessageSend('सन्देश पठाइएकाे छ');

        this.recaptchaInstance.reset();
        this.clearInputErrors();

        this.setState(
          {
            contact: {
              name: '',
              email: '',
              message: ''
            },
            contactFormVisible: false
          },
          () => {
            setTimeout(() => {
              this.setState({ isOpen: false }, () => {
                setTimeout(() => {
                  this.setState({ contactFormVisible: true });
                }, 1000);
              });
            }, 4000);
          }
        );
      } else {
        this.props.onMessageError('Error Occurred');

        this.clearInputErrors();

        this.setState({
          isOpen: false,
          contact: {
            name: '',
            email: '',
            message: ''
          }
        });
      }
      // this.setState({
      //   isOpen: false
      // });
    });
  };

  onRecaptchaResponse = response => {
    if (response) {
      this.setState({
        captchaValidated: true
      });
    }
  };

  callback() {}

  changeRecaptchaText = () => {
    document
      .getElementById('g-recaptcha')
      .insertAdjacentHTML('afterbegin', '<div id="new_label"></div>');
    let newLabel = document.getElementById('new_label');
    newLabel.innerText = 'म यो सन्देश पठाउन चाहन्छु ।';
    let style = newLabel.style;
    style.position = 'absolute';
    style.top = '28px';
    style.left = '53px';
    style.backgroundColor = '#f9f9f9';
    style.fontSize = '12px';
  };

  renderActions() {
    return (
      <div>
        <Button captchaValidated={this.state.captchaValidated} className="button">
          {strings.contact.submitMessage}
        </Button>
      </div>
    );
  }

  render() {
    const { isOpen, contactFormVisible } = this.state;
    const transitionStyles = {
      entered: {
        opacity: 1,
        visibility: 'visible',
        transform: 'translateY(0)'
      }
    };

    const { municipality } = this.props;

    const munName =
      municipality.nameEn !== 'All Municipalities'
        ? strings.getLanguage() === 'np'
          ? municipality.name
          : municipality.nameEn
        : null;

    return (
      <Dropdown>
        <DropdownButton lang={strings.getLanguage()} onClick={this.menuToggle}>
          <img src={images.icons.mail} alt="" />
          <span>{strings.contact.contact}</span>
        </DropdownButton>

        <Transition in={isOpen} timeout={100} mountOnEnter={true}>
          {state => (
            <DropdownMenu
              style={{
                ...transitionStyles[state]
              }}
            >
              <DropdownContent>
                <SuccessMessage
                  style={contactFormVisible ? { display: 'none' } : { display: 'block' }}
                >
                  <img src={images.icons.message} alt="Success message" />
                  <Heading.h2>{strings.contact.success}</Heading.h2>
                  <Text.span>{strings.contact.successMessage}</Text.span>
                </SuccessMessage>
                <div style={contactFormVisible ? { display: 'block' } : { display: 'none' }}>
                  <div className="header">
                    <h2>
                      {munName === null ? (
                        <Fragment>{strings.contact.sendMessage}</Fragment>
                      ) : (
                        <Fragment>
                          {strings.getLanguage() === 'np'
                            ? `${munName}मा ${strings.contact.sendMessage}`
                            : `${strings.contact.sendMessage} to ${munName}`}
                        </Fragment>
                      )}
                    </h2>

                    <CloseIcon onClick={this.menuToggle} />
                  </div>
                  <Form onSubmit={this.handleFormSubmit} ref={c => (this.form = c)}>
                    <div className="form-group form-group--error" />
                    <div className="form-group form-group--half">
                      <div>
                        <label className="label" htmlFor="">
                          {strings.contact.labels.name}
                        </label>
                        <Input
                          type="text"
                          name="name"
                          value={this.state.contact.name}
                          onChange={this.handleOnChange}
                          validations={[requiredName]}
                          ref={c => {
                            this.userInputName = c;
                          }}
                        />
                      </div>
                      <div>
                        <label className="label" htmlFor="">
                          {strings.contact.labels.email}
                        </label>
                        <Input
                          value={this.state.contact.email}
                          name="email"
                          onChange={this.handleOnChange}
                          validations={[requiredEmail, email]}
                          ref={c => {
                            this.userInputEmail = c;
                          }}
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="label" htmlFor="">
                        {strings.contact.labels.message}
                      </label>
                      <Textarea
                        value={this.state.contact.message}
                        name="message"
                        onChange={this.handleOnChange}
                        validations={[requiredMessage]}
                        ref={c => {
                          this.userInputMessage = c;
                        }}
                      />
                    </div>

                    <Recaptcha
                      ref={e => (this.recaptchaInstance = e)}
                      sitekey="6LdYgkkUAAAAAMSYPEm2OmsYCE9wmML2CxeB67cW"
                      render="explicit"
                      verifyCallback={this.onRecaptchaResponse}
                      onloadCallback={this.callback}
                    />

                    <div className="form-group form-group--submit">{this.renderActions()}</div>
                  </Form>
                </div>
              </DropdownContent>
            </DropdownMenu>
          )}
        </Transition>
      </Dropdown>
    );
  }
}

const mapStateToProps = state => {
  return {
    selectedMun: state.filters.municipality.id,
    municipality: state.filters.municipality,
    detailPageMun: state.datahub.detailPageMun
  };
};

export default withRouter(connect(mapStateToProps)(Contact));

const Dropdown = styled.span`
  position: relative;
  // min-width: 200px;
`;

const DropdownButton = styled.span`
  color: #fff;
  font-size: ${props => (props.lang === 'en' ? '14px' : '16px')};
  padding: 10px 0 10px 10px;
  cursor: pointer;

  img {
    @media screen and (min-width: 768px) {
      display: none;
    }
  }

  span {
    @media screen and (max-width: 768px) {
      display: none;
    }
  }
`;

const DropdownMenu = styled.div`
  padding-top: 20px;
  position: absolute;
  top: 100%;
  z-index: 1000;
  opacity: 0;
  right: 0;
  width: 640px;
  visibility: hidden;
  transform: translateY(-4px);
  transition: all 300ms ease-in-out;

  @media screen and (max-width: 768px) {
    width: calc(100vw - 50px);
  }

  &:before {
    content: '';
    position: absolute;
    right: 22px;
    top: 10px;
    border-bottom: 12px solid #fff;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
`;

const DropdownContent = styled.div`
  background: white;
  border-radius: 14px;
  padding: 36px 42px;
  border: 1px solid rgba(151, 151, 151, 0.26);

  @media screen and (max-width: 768px) {
    padding: 18px 12px;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 28px;
    > h2 {
      color: #4a4a4a;
      font-size: 21px;
      margin-bottom: 8px;
      font-weight: 600;
    }

    > span {
      color: #4a4a4a;
      font-size: 14ppx;
    }
  }

  .form {
    .form-group {
      &:not(:last-child) {
        margin-bottom: 20px;
      }

      .label {
        display: block;
        color: #4a4a4a;
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 8px;

        &--disabled {
          color: #a0a0a0;
        }
      }

      input,
      textarea {
        &:focus {
          outline: none;
        }
      }

      input,
      textarea {
        &.is-invalid-input {
          border: 1px solid #d62300;
          background-color: rgba(214, 35, 0, 0.06);
        }
      }

      input:required,
      textarea:required,
      input:invalid,
      textarea:invalid {
        box-shadow: none;
      }

      input {
        font-size: 15px;
        height: 42px;
        width: 100%;
        background: rgb(240, 248, 255);
        border-width: 1px;
        border-style: solid;
        border-color: rgb(229, 230, 232);
        border-image: initial;
        border-radius: 2px;
        padding: 6px;
      }

      textarea {
        width: 100%;
        background: rgb(240, 248, 255);
        border-width: 1px;
        border-style: solid;
        border-color: rgb(229, 230, 232);
        border-image: initial;
        height: 130px;
        border-radius: 2px;
        padding: 6px;
        font-size: 15px;
        resize: vertical;
      }

      .button {
        padding: 10px 22px;
        font-size: 14px;
        font-weight: 600;
        display: inline-block;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        user-select: none;
        color: rgb(255, 255, 255);
        cursor: pointer;
        border-width: 0px;
        border-style: initial;
        border-color: initial;
        border-image: initial;
        border-radius: 18px;
        background: rgb(30, 168, 158);
        transition: background 0.1s ease-in;

        &:hover {
          background: #01887e;
        }

        &:disabled {
          cursor: not-allowed;
        }
      }

      .error {
        color: #d62300;
        font-size: 12px;
        display: block;
        margin-top: 7px;
      }

      &--half {
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        @media screen and (max-width: 600px) {
          flex-direction: column;
        }

        > div {
          width: calc(50% - 10px);
          @media screen and (max-width: 600px) {
            width: 100%;

            &:first-child {
              margin-bottom: 20px;
            }
          }
        }
      }

      &--checkbox {
        .label {
          margin-bottom: 12px;
        }

        .custom-checkbox {
          color: #737b81;
        }

        .checkbox-list {
          display: flex;
          flex-wrap: wrap;

          > label {
            flex: 1;
          }
        }
      }

      &--submit {
        margin-top: 36px;
        button {
          &:first-child {
            margin-right: 14px;
          }
        }
      }
    }
  }
`;

const CloseIcon = styled.div`
  color: ${props => props.theme.primary.ujyaalo};
  width: 21px;
  height: 21px;
  cursor: pointer;
  position: relative;

  &:before {
    content: '';
    position: absolute;
    top: 10px;
    width: 21px;
    height: 1px;
    background-color: currentColor;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
  &:after {
    content: '';
    position: absolute;
    top: 10px;
    width: 21px;
    height: 1px;
    background-color: currentColor;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`;

const SuccessMessage = styled.div`
  text-align: center;
  padding: 24px 0;

  img,
  h2 {
    margin-bottom: 12px;
  }

  h2 {
    color: ${props => props.theme.teals.tilicho};
    font-weight: 400;
  }
`;



// WEBPACK FOOTER //
// ./src/components/layouts/contact/contact.js